import React from 'react';
import { useTranslation } from 'react-i18next';

import EnergyRevenueOverlayChart from '../location-comparison/EnergyRevenueOverlayChart';
// import SessionCountPerLocationChart from '../location-comparison/SessionCountPerLocationChart';
import LocationComparisonList from '../location-comparison/LocationComparisonList';
import UptimeTrendOverTimeChart from '../location-comparison/UptimeTrendOverTimeChart';

/**
 * Station Comparison
 * @returns {any} The rendered component
 */
function LocationComparison() {
  const { t, i18n } = useTranslation('sidePanel');

  return (
    <div className="location-comparison-main" dir={i18n.dir()}>
      <LocationComparisonList />
      <p className="graph-view">{t('graphView')}</p>
      <div className="location-comparison-chart">
        <EnergyRevenueOverlayChart />
        {/* <SessionCountPerLocationChart /> */}
        <UptimeTrendOverTimeChart />
      </div>
    </div>
  );
}

export default LocationComparison;
